<template>
  <div>
    <v-form ref="form">
      <v-row row no-gutters class="flex-nowrap" align="center">
        <v-col xs12 sm12 md8 lg6>
          <v-file-input
            small-chips
            show-size
            :rules="rules"
            :accept="accept"
            :label="label"
            :error="error"
            error-count="20"
            :error-messages="errorMessages"
            :success-messages="successMessages"
            ref="file"
            v-on:change="handleFileChange"
          />
        </v-col>
        <v-col xs12 sm6 md4 lg3 v-show="fileExists() && !fileUploaded">
          <v-btn
            style="margin-left:5px;"
            :disabled="!fileExists() || uploading"
            :loading="uploading"
            @click="upload"
            color="primary"
          >{{$t('globals.upload')}}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiService from "../services/api.service";
import { locker } from "../mixins/locker";
export default {
  name: "file-uploader",
  props: {
    accept: String,
    label: String,
    rules: Array,
    url: String,
    successMessages: [String, Array],
    errorMessages: [String, Array],
    uploading: Boolean,
    autoUpload: {
      type: Boolean,
      default: () => false
    },
    mustLock: {
      type: Boolean,
      default: () => true
    }
  },
  mixins: [locker],
  mounted() {},
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  data() {
    return {
      file: null,
      error: false,
      fileUploaded: false
    };
  },
  methods: {
    fileExists() {
      //console.log("----------------------------", this.file);
      return this.file && this.file.name && this.file.name.length > 0;
    },
    reset() {
      this.file = null;
      this.$refs.form.reset();
      this.$el.querySelector("input").type = "text";
      this.$el.querySelector("input").type = "file";
    },
    upload() {
      this.submitFile();
    },
    handleFileChange(file) {
      console.log(file);
      if(!file) {
        this.file = null;
        this.$emit("clear");
        return;
      }
      if (file.length == 0){
        return;
      }
      this.file = file;
      this.fileUploaded = false;
      if (this.file && this.autoUpload) {
        this.submitFile();
      }
    },
    async submitFile() {
      
      this.$emit("upload-started");
      if (this.mustLock) {
         try {
        
        const res = await this.lock(this.postFile, {planId:this.selectedPlan.Id}, () => {
          this.$emit("lock-expired");
        });
        this.fileUploaded = true;
        this.$emit("upload-completed", res);
      } catch (error) {
        if (error.response) {
          this.unlock(error.response.headers["lock-id"]);
        }
        this.$emit("upload-error", error);
      } 
        } else {
          try {
        
        const res = await this.postFile();
        this.fileUploaded = true;
        this.$emit("upload-completed", res);
      } catch (error) {
        console.log(error);
        this.$emit("upload-error", error);
      }
        }
    },
    postFile() {
      let formData = new FormData();
      formData.append("file", this.file);
      return ApiService.postFile(this.url, formData);
    }
  }
};
</script>

<style>
</style>